export const flags_json = {
  "AE-AJ": "/i/flags/AE/AE-AJ.svg.png",
  "AE-AZ": "/i/flags/AE/AE-AZ.svg.png",
  "AE-DU": "/i/flags/AE/AE-DU.svg.png",
  "AE-FU": "/i/flags/AE/AE-FU.svg.png",
  "AE-RK": "/i/flags/AE/AE-RK.svg.png",
  "AE-SH": "/i/flags/AE/AE-SH.svg.png",
  "AE-UQ": "/i/flags/AE/AE-UQ.svg.png",
  "AR-A": "/i/flags/AR/AR-A.svg.png",
  "AR-B": "/i/flags/AR/AR-B.svg.png",
  "AR-C": "/i/flags/AR/AR-C.svg.png",
  "AR-D": "/i/flags/AR/AR-D.svg.png",
  "AR-E": "/i/flags/AR/AR-E.svg.png",
  "AR-F": "/i/flags/AR/AR-F.svg.png",
  "AR-G": "/i/flags/AR/AR-G.svg.png",
  "AR-H": "/i/flags/AR/AR-H.svg.png",
  "AR-J": "/i/flags/AR/AR-J.svg.png",
  "AR-K": "/i/flags/AR/AR-K.svg.png",
  "AR-L": "/i/flags/AR/AR-L.svg.png",
  "AR-M": "/i/flags/AR/AR-M.svg.png",
  "AR-N": "/i/flags/AR/AR-N.svg.png",
  "AR-P": "/i/flags/AR/AR-P.svg.png",
  "AR-Q": "/i/flags/AR/AR-Q.svg.png",
  "AR-R": "/i/flags/AR/AR-R.svg.png",
  "AR-S": "/i/flags/AR/AR-S.svg.png",
  "AR-T": "/i/flags/AR/AR-T.svg.png",
  "AR-U": "/i/flags/AR/AR-U.svg.png",
  "AR-V": "/i/flags/AR/AR-V.svg.png",
  "AR-W": "/i/flags/AR/AR-W.svg.png",
  "AR-X": "/i/flags/AR/AR-X.svg.png",
  "AR-Y": "/i/flags/AR/AR-Y.svg.png",
  "AR-Z": "/i/flags/AR/AR-Z.svg.png",
  "AT-1": "/i/flags/AT/AT-1.svg.png",
  "AT-2": "/i/flags/AT/AT-2.svg.png",
  "AT-3": "/i/flags/AT/AT-3.svg.png",
  "AT-4": "/i/flags/AT/AT-4.svg.png",
  "AT-5": "/i/flags/AT/AT-5.svg.png",
  "AT-6": "/i/flags/AT/AT-6.svg.png",
  "AT-7": "/i/flags/AT/AT-7.svg.png",
  "AT-8": "/i/flags/AT/AT-8.svg.png",
  "AT-9": "/i/flags/AT/AT-9.svg.png",
  "AU-ACT": "/i/flags/AU/AU-ACT.svg.png",
  "AU-LDH": "/i/flags/AU/AU-LDH.svg.png",
  "AU-NSW": "/i/flags/AU/AU-NSW.svg.png",
  "AU-NT": "/i/flags/AU/AU-NT.svg.png",
  "AU-QLD": "/i/flags/AU/AU-QLD.svg.png",
  "AU-SA": "/i/flags/AU/AU-SA.svg.png",
  "AU-TAS": "/i/flags/AU/AU-TAS.svg.png",
  "AU-VIC": "/i/flags/AU/AU-VIC.svg.png",
  "AU-WA": "/i/flags/AU/AU-WA.svg.png",
  "BA-BIH": "/i/flags/BA/BA-BIH.svg.png",
  "BA-BRC": "/i/flags/BA/BA-BRC.svg.png",
  "BA-SRP": "/i/flags/BA/BA-SRP.svg.png",
  "BE-BRU": "/i/flags/BE/BE-BRU.svg.png",
  "BE-VLG": "/i/flags/BE/BE-VLG.svg.png",
  "BE-WAL": "/i/flags/BE/BE-WAL.svg.png",
  "BQ-BO": "/i/flags/BQ/BQ-BO.svg.png",
  "BQ-SA": "/i/flags/BQ/BQ-SA.svg.png",
  "BQ-SE": "/i/flags/BQ/BQ-SE.svg.png",
  "BR-AC": "/i/flags/BR/BR-AC.svg.png",
  "BR-AL": "/i/flags/BR/BR-AL.svg.png",
  "BR-AM": "/i/flags/BR/BR-AM.svg.png",
  "BR-AP": "/i/flags/BR/BR-AP.svg.png",
  "BR-BA": "/i/flags/BR/BR-BA.svg.png",
  "BR-CE": "/i/flags/BR/BR-CE.svg.png",
  "BR-DF": "/i/flags/BR/BR-DF.svg.png",
  "BR-ES": "/i/flags/BR/BR-ES.svg.png",
  "BR-GO": "/i/flags/BR/BR-GO.svg.png",
  "BR-MA": "/i/flags/BR/BR-MA.svg.png",
  "BR-MG": "/i/flags/BR/BR-MG.svg.png",
  "BR-MS": "/i/flags/BR/BR-MS.svg.png",
  "BR-MT": "/i/flags/BR/BR-MT.svg.png",
  "BR-PA": "/i/flags/BR/BR-PA.svg.png",
  "BR-PB": "/i/flags/BR/BR-PB.svg.png",
  "BR-PE": "/i/flags/BR/BR-PE.svg.png",
  "BR-PE:1": "/i/flags/BR/BR-PE:1.svg.png",
  "BR-PI": "/i/flags/BR/BR-PI.svg.png",
  "BR-PR": "/i/flags/BR/BR-PR.svg.png",
  "BR-RJ": "/i/flags/BR/BR-RJ.svg.png",
  "BR-RN": "/i/flags/BR/BR-RN.svg.png",
  "BR-RO": "/i/flags/BR/BR-RO.svg.png",
  "BR-RR": "/i/flags/BR/BR-RR.svg.png",
  "BR-RS": "/i/flags/BR/BR-RS.svg.png",
  "BR-SC": "/i/flags/BR/BR-SC.svg.png",
  "BR-SE": "/i/flags/BR/BR-SE.svg.png",
  "BR-SP": "/i/flags/BR/BR-SP.svg.png",
  "BR-TO": "/i/flags/BR/BR-TO.svg.png",
  "CA-AB": "/i/flags/CA/CA-AB.svg.png",
  "CA-BC": "/i/flags/CA/CA-BC.svg.png",
  "CA-MB": "/i/flags/CA/CA-MB.svg.png",
  "CA-NB": "/i/flags/CA/CA-NB.svg.png",
  "CA-NL": "/i/flags/CA/CA-NL.svg.png",
  "CA-NS": "/i/flags/CA/CA-NS.svg.png",
  "CA-NT": "/i/flags/CA/CA-NT.svg.png",
  "CA-NU": "/i/flags/CA/CA-NU.svg.png",
  "CA-ON": "/i/flags/CA/CA-ON.svg.png",
  "CA-PE": "/i/flags/CA/CA-PE.svg.png",
  "CA-QC": "/i/flags/CA/CA-QC.svg.png",
  "CA-SK": "/i/flags/CA/CA-SK.svg.png",
  "CA-YT": "/i/flags/CA/CA-YT.svg.png",
  "CH-AG": "/i/flags/CH/CH-AG.svg.png",
  "CH-AI": "/i/flags/CH/CH-AI.svg.png",
  "CH-AR": "/i/flags/CH/CH-AR.svg.png",
  "CH-BE": "/i/flags/CH/CH-BE.svg.png",
  "CH-BL": "/i/flags/CH/CH-BL.svg.png",
  "CH-BS": "/i/flags/CH/CH-BS.svg.png",
  "CH-FR": "/i/flags/CH/CH-FR.svg.png",
  "CH-GE": "/i/flags/CH/CH-GE.svg.png",
  "CH-GL": "/i/flags/CH/CH-GL.svg.png",
  "CH-GR": "/i/flags/CH/CH-GR.svg.png",
  "CH-JU": "/i/flags/CH/CH-JU.svg.png",
  "CH-LU": "/i/flags/CH/CH-LU.svg.png",
  "CH-NE": "/i/flags/CH/CH-NE.svg.png",
  "CH-NW": "/i/flags/CH/CH-NW.svg.png",
  "CH-OW": "/i/flags/CH/CH-OW.svg.png",
  "CH-SG": "/i/flags/CH/CH-SG.svg.png",
  "CH-SH": "/i/flags/CH/CH-SH.svg.png",
  "CH-SO": "/i/flags/CH/CH-SO.svg.png",
  "CH-SZ": "/i/flags/CH/CH-SZ.svg.png",
  "CH-TG": "/i/flags/CH/CH-TG.svg.png",
  "CH-TI": "/i/flags/CH/CH-TI.svg.png",
  "CH-UR": "/i/flags/CH/CH-UR.svg.png",
  "CH-VD": "/i/flags/CH/CH-VD.svg.png",
  "CH-VS": "/i/flags/CH/CH-VS.svg.png",
  "CH-ZG": "/i/flags/CH/CH-ZG.svg.png",
  "CH-ZH": "/i/flags/CH/CH-ZH.svg.png",
  "CL-VS:1": "/i/flags/CL/CL-VS:1.svg.png",
  "CL-VS:2": "/i/flags/CL/CL-VS:2.svg.png",
  "CO-SAP": "/i/flags/CO/CO-SAP.svg.png",
  "CRIMEA": "/i/flags/CRIMEA.svg.png",
  "DE-BB": "/i/flags/DE/DE-BB.svg.png",
  "DE-BE": "/i/flags/DE/DE-BE.svg.png",
  "DE-BW": "/i/flags/DE/DE-BW.svg.png",
  "DE-BY": "/i/flags/DE/DE-BY.svg.png",
  "DE-HB": "/i/flags/DE/DE-HB.svg.png",
  "DE-HE": "/i/flags/DE/DE-HE.svg.png",
  "DE-HH": "/i/flags/DE/DE-HH.svg.png",
  "DE-MV": "/i/flags/DE/DE-MV.svg.png",
  "DE-NI": "/i/flags/DE/DE-NI.svg.png",
  "DE-NW": "/i/flags/DE/DE-NW.svg.png",
  "DE-RP": "/i/flags/DE/DE-RP.svg.png",
  "DE-SH": "/i/flags/DE/DE-SH.svg.png",
  "DE-SL": "/i/flags/DE/DE-SL.svg.png",
  "DE-SN": "/i/flags/DE/DE-SN.svg.png",
  "DE-ST": "/i/flags/DE/DE-ST.svg.png",
  "DE-TH": "/i/flags/DE/DE-TH.svg.png",
  "DK-040": "/i/flags/DK/DK-040.svg.png",
  "EC-W": "/i/flags/EC/EC-W.svg.png",
  "ES-AN": "/i/flags/ES/ES-AN.svg.png",
  "ES-AR": "/i/flags/ES/ES-AR.svg.png",
  "ES-AS": "/i/flags/ES/ES-AS.svg.png",
  "ES-CB": "/i/flags/ES/ES-CB.svg.png",
  "ES-CE": "/i/flags/ES/ES-CE.svg.png",
  "ES-CL": "/i/flags/ES/ES-CL.svg.png",
  "ES-CM": "/i/flags/ES/ES-CM.svg.png",
  "ES-CN": "/i/flags/ES/ES-CN.svg.png",
  "ES-CT": "/i/flags/ES/ES-CT.svg.png",
  "ES-EX": "/i/flags/ES/ES-EX.svg.png",
  "ES-GA": "/i/flags/ES/ES-GA.svg.png",
  "ES-IB": "/i/flags/ES/ES-IB.svg.png",
  "ES-MC": "/i/flags/ES/ES-MC.svg.png",
  "ES-MD": "/i/flags/ES/ES-MD.svg.png",
  "ES-ML": "/i/flags/ES/ES-ML.svg.png",
  "ES-NC": "/i/flags/ES/ES-NC.svg.png",
  "ES-PV": "/i/flags/ES/ES-PV.svg.png",
  "ES-RI": "/i/flags/ES/ES-RI.svg.png",
  "ES-VC": "/i/flags/ES/ES-VC.svg.png",
  "ET-AA": "/i/flags/ET/ET-AA.svg.png",
  "ET-AF": "/i/flags/ET/ET-AF.svg.png",
  "ET-AM": "/i/flags/ET/ET-AM.svg.png",
  "ET-BE": "/i/flags/ET/ET-BE.svg.png",
  "ET-GA": "/i/flags/ET/ET-GA.svg.png",
  "ET-HA": "/i/flags/ET/ET-HA.svg.png",
  "ET-OR": "/i/flags/ET/ET-OR.svg.png",
  "ET-SI": "/i/flags/ET/ET-SI.svg.png",
  "ET-SN": "/i/flags/ET/ET-SN.svg.png",
  "ET-SO": "/i/flags/ET/ET-SO.svg.png",
  "ET-SW": "/i/flags/ET/ET-SW.svg.png",
  "ET-TI": "/i/flags/ET/ET-TI.svg.png",
  "FM-KSA": "/i/flags/FM/FM-KSA.svg.png",
  "FM-PNI": "/i/flags/FM/FM-PNI.svg.png",
  "FM-TRK": "/i/flags/FM/FM-TRK.svg.png",
  "FM-YAP": "/i/flags/FM/FM-YAP.svg.png",
  "FR-A": "/i/flags/FR/FR-A.svg.png",
  "FR-B": "/i/flags/FR/FR-B.svg.png",
  "FR-BL": "/i/flags/FR/FR-BL.svg.png",
  "FR-C": "/i/flags/FR/FR-C.svg.png",
  "FR-CP": "/i/flags/FR/FR-CP.svg.png",
  "FR-D": "/i/flags/FR/FR-D.svg.png",
  "FR-E": "/i/flags/FR/FR-E.svg.png",
  "FR-F": "/i/flags/FR/FR-F.svg.png",
  "FR-G": "/i/flags/FR/FR-G.svg.png",
  "FR-H": "/i/flags/FR/FR-H.svg.png",
  "FR-I": "/i/flags/FR/FR-I.svg.png",
  "FR-J": "/i/flags/FR/FR-J.svg.png",
  "FR-K": "/i/flags/FR/FR-K.svg.png",
  "FR-L": "/i/flags/FR/FR-L.svg.png",
  "FR-M": "/i/flags/FR/FR-M.svg.png",
  "FR-MF": "/i/flags/FR/FR-MF.svg.png",
  "FR-N": "/i/flags/FR/FR-N.svg.png",
  "FR-NC": "/i/flags/FR/FR-NC.svg.png",
  "FR-O": "/i/flags/FR/FR-O.svg.png",
  "FR-P": "/i/flags/FR/FR-P.svg.png",
  "FR-PF": "/i/flags/FR/FR-PF.svg.png",
  "FR-PM": "/i/flags/FR/FR-PM.svg.png",
  "FR-Q": "/i/flags/FR/FR-Q.svg.png",
  "FR-R": "/i/flags/FR/FR-R.svg.png",
  "FR-S": "/i/flags/FR/FR-S.svg.png",
  "FR-T": "/i/flags/FR/FR-T.svg.png",
  "FR-TF": "/i/flags/FR/FR-TF.svg.png",
  "FR-U": "/i/flags/FR/FR-U.svg.png",
  "FR-V": "/i/flags/FR/FR-V.svg.png",
  "FR-WF": "/i/flags/FR/FR-WF.svg.png",
  "GB-AGY": "/i/flags/GB/GB-AGY.svg.png",
  "GB-ELS": "/i/flags/GB/GB-ELS.svg.png",
  "GB-ENG": "/i/flags/GB/GB-ENG.svg.png",
  "GB-IOS": "/i/flags/GB/GB-IOS.svg.png",
  "GB-NIR": "/i/flags/GB/GB-NIR.svg.png",
  "GB-ORK": "/i/flags/GB/GB-ORK.svg.png",
  "GB-SCT": "/i/flags/GB/GB-SCT.svg.png",
  "GB-WLS": "/i/flags/GB/GB-WLS.svg.png",
  "GB-ZET": "/i/flags/GB/GB-ZET.svg.png",
  "GR-69": "/i/flags/GR/GR-69.svg.png",
  "HR-18": "/i/flags/HR/HR-18.svg.png",
  "HR-C": "/i/flags/HR/HR-C.svg.png",
  "HR-D": "/i/flags/HR/HR-D.svg.png",
  "HR-K": "/i/flags/HR/HR-K.svg.png",
  "HR-S": "/i/flags/HR/HR-S.svg.png",
  "ID-AC": "/i/flags/ID/ID-AC.svg.png",
  "ID-BA": "/i/flags/ID/ID-BA.svg.png",
  "ID-BB": "/i/flags/ID/ID-BB.svg.png",
  "ID-BE": "/i/flags/ID/ID-BE.svg.png",
  "ID-BT": "/i/flags/ID/ID-BT.svg.png",
  "ID-GO": "/i/flags/ID/ID-GO.svg.png",
  "ID-JA": "/i/flags/ID/ID-JA.svg.png",
  "ID-JB": "/i/flags/ID/ID-JB.svg.png",
  "ID-JI": "/i/flags/ID/ID-JI.svg.png",
  "ID-JK": "/i/flags/ID/ID-JK.svg.png",
  "ID-JT": "/i/flags/ID/ID-JT.svg.png",
  "ID-KB": "/i/flags/ID/ID-KB.svg.png",
  "ID-KI": "/i/flags/ID/ID-KI.svg.png",
  "ID-KR": "/i/flags/ID/ID-KR.svg.png",
  "ID-KS": "/i/flags/ID/ID-KS.svg.png",
  "ID-KT": "/i/flags/ID/ID-KT.svg.png",
  "ID-KU": "/i/flags/ID/ID-KU.svg.png",
  "ID-LA": "/i/flags/ID/ID-LA.svg.png",
  "ID-MA": "/i/flags/ID/ID-MA.svg.png",
  "ID-MU": "/i/flags/ID/ID-MU.svg.png",
  "ID-NB": "/i/flags/ID/ID-NB.svg.png",
  "ID-NT": "/i/flags/ID/ID-NT.svg.png",
  "ID-PA": "/i/flags/ID/ID-PA.svg.png",
  "ID-PB": "/i/flags/ID/ID-PB.svg.png",
  "ID-PD": "/i/flags/ID/ID-PD.svg.png",
  "ID-PE": "/i/flags/ID/ID-PE.svg.png",
  "ID-PS": "/i/flags/ID/ID-PS.svg.png",
  "ID-PT": "/i/flags/ID/ID-PT.svg.png",
  "ID-RI": "/i/flags/ID/ID-RI.svg.png",
  "ID-SA": "/i/flags/ID/ID-SA.svg.png",
  "ID-SB": "/i/flags/ID/ID-SB.svg.png",
  "ID-SG": "/i/flags/ID/ID-SG.svg.png",
  "ID-SN": "/i/flags/ID/ID-SN.svg.png",
  "ID-SR": "/i/flags/ID/ID-SR.svg.png",
  "ID-SS": "/i/flags/ID/ID-SS.svg.png",
  "ID-ST": "/i/flags/ID/ID-ST.svg.png",
  "ID-SU": "/i/flags/ID/ID-SU.svg.png",
  "ID-YO": "/i/flags/ID/ID-YO.svg.png",
  "IE-C": "/i/flags/IE/IE-C.svg.png",
  "IE-L": "/i/flags/IE/IE-L.svg.png",
  "IE-M": "/i/flags/IE/IE-M.svg.png",
  "IE-U": "/i/flags/IE/IE-U.svg.png",
  "IQ-KR": "/i/flags/IQ/IQ-KR.svg.png",
  "IT-21": "/i/flags/IT/IT-21.svg.png",
  "IT-23": "/i/flags/IT/IT-23.svg.png",
  "IT-25": "/i/flags/IT/IT-25.svg.png",
  "IT-32": "/i/flags/IT/IT-32.svg.png",
  "IT-34": "/i/flags/IT/IT-34.svg.png",
  "IT-36": "/i/flags/IT/IT-36.svg.png",
  "IT-42": "/i/flags/IT/IT-42.svg.png",
  "IT-45": "/i/flags/IT/IT-45.svg.png",
  "IT-52": "/i/flags/IT/IT-52.svg.png",
  "IT-55": "/i/flags/IT/IT-55.svg.png",
  "IT-57": "/i/flags/IT/IT-57.svg.png",
  "IT-62": "/i/flags/IT/IT-62.svg.png",
  "IT-65": "/i/flags/IT/IT-65.svg.png",
  "IT-67": "/i/flags/IT/IT-67.svg.png",
  "IT-72": "/i/flags/IT/IT-72.svg.png",
  "IT-75": "/i/flags/IT/IT-75.svg.png",
  "IT-77": "/i/flags/IT/IT-77.svg.png",
  "IT-78": "/i/flags/IT/IT-78.svg.png",
  "IT-82": "/i/flags/IT/IT-82.svg.png",
  "IT-88": "/i/flags/IT/IT-88.svg.png",
  "JP-01": "/i/flags/JP/JP-01.svg.png",
  "JP-13:1": "/i/flags/JP/JP-13:1.svg.png",
  "JP-47": "/i/flags/JP/JP-47.svg.png",
  "KN-K": "/i/flags/KN/KN-K.svg.png",
  "KN-N": "/i/flags/KN/KN-N.svg.png",
  "MD-GA": "/i/flags/MD/MD-GA.svg.png",
  "MT-G": "/i/flags/MT/MT-G.svg.png",
  "MU-RO": "/i/flags/MU/MU-RO.svg.png",
  "MX-AGU": "/i/flags/MX/MX-AGU.svg.png",
  "MX-BCN": "/i/flags/MX/MX-BCN.svg.png",
  "MX-BCS": "/i/flags/MX/MX-BCS.svg.png",
  "MX-CAM": "/i/flags/MX/MX-CAM.svg.png",
  "MX-CHH": "/i/flags/MX/MX-CHH.svg.png",
  "MX-CHP": "/i/flags/MX/MX-CHP.svg.png",
  "MX-CMX": "/i/flags/MX/MX-CMX.svg.png",
  "MX-COA": "/i/flags/MX/MX-COA.svg.png",
  "MX-COL": "/i/flags/MX/MX-COL.svg.png",
  "MX-DUR": "/i/flags/MX/MX-DUR.svg.png",
  "MX-GRO": "/i/flags/MX/MX-GRO.svg.png",
  "MX-GUA": "/i/flags/MX/MX-GUA.svg.png",
  "MX-HID": "/i/flags/MX/MX-HID.svg.png",
  "MX-JAL": "/i/flags/MX/MX-JAL.svg.png",
  "MX-MEX": "/i/flags/MX/MX-MEX.svg.png",
  "MX-MIC": "/i/flags/MX/MX-MIC.svg.png",
  "MX-MOR": "/i/flags/MX/MX-MOR.svg.png",
  "MX-NAY": "/i/flags/MX/MX-NAY.svg.png",
  "MX-NLE": "/i/flags/MX/MX-NLE.svg.png",
  "MX-OAX": "/i/flags/MX/MX-OAX.svg.png",
  "MX-PUE": "/i/flags/MX/MX-PUE.svg.png",
  "MX-QUE": "/i/flags/MX/MX-QUE.svg.png",
  "MX-ROO": "/i/flags/MX/MX-ROO.svg.png",
  "MX-SIN": "/i/flags/MX/MX-SIN.svg.png",
  "MX-SLP": "/i/flags/MX/MX-SLP.svg.png",
  "MX-SON": "/i/flags/MX/MX-SON.svg.png",
  "MX-TAB": "/i/flags/MX/MX-TAB.svg.png",
  "MX-TAM": "/i/flags/MX/MX-TAM.svg.png",
  "MX-TLA": "/i/flags/MX/MX-TLA.svg.png",
  "MX-VER": "/i/flags/MX/MX-VER.svg.png",
  "MX-YUC": "/i/flags/MX/MX-YUC.svg.png",
  "MX-ZAC": "/i/flags/MX/MX-ZAC.svg.png",
  "MY-01": "/i/flags/MY/MY-01.svg.png",
  "MY-02": "/i/flags/MY/MY-02.svg.png",
  "MY-03": "/i/flags/MY/MY-03.svg.png",
  "MY-04": "/i/flags/MY/MY-04.svg.png",
  "MY-05": "/i/flags/MY/MY-05.svg.png",
  "MY-06": "/i/flags/MY/MY-06.svg.png",
  "MY-07": "/i/flags/MY/MY-07.svg.png",
  "MY-08": "/i/flags/MY/MY-08.svg.png",
  "MY-09": "/i/flags/MY/MY-09.svg.png",
  "MY-10": "/i/flags/MY/MY-10.svg.png",
  "MY-11": "/i/flags/MY/MY-11.svg.png",
  "MY-12": "/i/flags/MY/MY-12.svg.png",
  "MY-13": "/i/flags/MY/MY-13.svg.png",
  "MY-14": "/i/flags/MY/MY-14.svg.png",
  "MY-15": "/i/flags/MY/MY-15.svg.png",
  "MY-16": "/i/flags/MY/MY-16.svg.png",
  "NC:LIP": "/i/flags/NC/NC:LIP.svg.png",
  "NC:NP": "/i/flags/NC/NC:NP.svg.png",
  "NC:SP": "/i/flags/NC/NC:SP.svg.png",
  "NZ-CIT": "/i/flags/NZ/NZ-CIT.svg.png",
  "PF:A": "/i/flags/PF/PF:A.svg.png",
  "PF:G": "/i/flags/PF/PF:G.svg.png",
  "PF:M": "/i/flags/PF/PF:M.svg.png",
  "PF:T": "/i/flags/PF/PF:T.svg.png",
  "PK-BA": "/i/flags/PK/PK-BA.svg.png",
  "PK-GB": "/i/flags/PK/PK-GB.svg.png",
  "PK-IS": "/i/flags/PK/PK-IS.svg.png",
  "PK-JK": "/i/flags/PK/PK-JK.svg.png",
  "PK-KP": "/i/flags/PK/PK-KP.svg.png",
  "PK-PB": "/i/flags/PK/PK-PB.svg.png",
  "PK-SD": "/i/flags/PK/PK-SD.svg.png",
  "PT-20": "/i/flags/PT/PT-20.svg.png",
  "PT-30": "/i/flags/PT/PT-30.svg.png",
  "RS-VO": "/i/flags/RS/RS-VO.svg.png",
  "RU-AD": "/i/flags/RU/RU-AD.svg.png",
  "RU-AL": "/i/flags/RU/RU-AL.svg.png",
  "RU-ALT": "/i/flags/RU/RU-ALT.svg.png",
  "RU-AMU": "/i/flags/RU/RU-AMU.svg.png",
  "RU-ARK": "/i/flags/RU/RU-ARK.svg.png",
  "RU-AST": "/i/flags/RU/RU-AST.svg.png",
  "RU-BA": "/i/flags/RU/RU-BA.svg.png",
  "RU-BEL": "/i/flags/RU/RU-BEL.svg.png",
  "RU-BRY": "/i/flags/RU/RU-BRY.svg.png",
  "RU-BU": "/i/flags/RU/RU-BU.svg.png",
  "RU-CE": "/i/flags/RU/RU-CE.svg.png",
  "RU-CHE": "/i/flags/RU/RU-CHE.svg.png",
  "RU-CHU": "/i/flags/RU/RU-CHU.svg.png",
  "RU-CU": "/i/flags/RU/RU-CU.svg.png",
  "RU-DA": "/i/flags/RU/RU-DA.svg.png",
  "RU-IN": "/i/flags/RU/RU-IN.svg.png",
  "RU-IRK": "/i/flags/RU/RU-IRK.svg.png",
  "RU-IVA": "/i/flags/RU/RU-IVA.svg.png",
  "RU-KAM": "/i/flags/RU/RU-KAM.svg.png",
  "RU-KB": "/i/flags/RU/RU-KB.svg.png",
  "RU-KC": "/i/flags/RU/RU-KC.svg.png",
  "RU-KDA": "/i/flags/RU/RU-KDA.svg.png",
  "RU-KEM": "/i/flags/RU/RU-KEM.svg.png",
  "RU-KGD": "/i/flags/RU/RU-KGD.svg.png",
  "RU-KGN": "/i/flags/RU/RU-KGN.svg.png",
  "RU-KHA": "/i/flags/RU/RU-KHA.svg.png",
  "RU-KHM": "/i/flags/RU/RU-KHM.svg.png",
  "RU-KIR": "/i/flags/RU/RU-KIR.svg.png",
  "RU-KK": "/i/flags/RU/RU-KK.svg.png",
  "RU-KL": "/i/flags/RU/RU-KL.svg.png",
  "RU-KLU": "/i/flags/RU/RU-KLU.svg.png",
  "RU-KO": "/i/flags/RU/RU-KO.svg.png",
  "RU-KOS": "/i/flags/RU/RU-KOS.svg.png",
  "RU-KR": "/i/flags/RU/RU-KR.svg.png",
  "RU-KRS": "/i/flags/RU/RU-KRS.svg.png",
  "RU-KYA": "/i/flags/RU/RU-KYA.svg.png",
  "RU-LEN": "/i/flags/RU/RU-LEN.svg.png",
  "RU-LIP": "/i/flags/RU/RU-LIP.svg.png",
  "RU-MAG": "/i/flags/RU/RU-MAG.svg.png",
  "RU-ME": "/i/flags/RU/RU-ME.svg.png",
  "RU-MO": "/i/flags/RU/RU-MO.svg.png",
  "RU-MOS": "/i/flags/RU/RU-MOS.svg.png",
  "RU-MOW": "/i/flags/RU/RU-MOW.svg.png",
  "RU-MUR": "/i/flags/RU/RU-MUR.svg.png",
  "RU-NEN": "/i/flags/RU/RU-NEN.svg.png",
  "RU-NGR": "/i/flags/RU/RU-NGR.svg.png",
  "RU-NIZ": "/i/flags/RU/RU-NIZ.svg.png",
  "RU-NVS": "/i/flags/RU/RU-NVS.svg.png",
  "RU-OMS": "/i/flags/RU/RU-OMS.svg.png",
  "RU-ORE": "/i/flags/RU/RU-ORE.svg.png",
  "RU-ORL": "/i/flags/RU/RU-ORL.svg.png",
  "RU-PER": "/i/flags/RU/RU-PER.svg.png",
  "RU-PNZ": "/i/flags/RU/RU-PNZ.svg.png",
  "RU-PRI": "/i/flags/RU/RU-PRI.svg.png",
  "RU-PSK": "/i/flags/RU/RU-PSK.svg.png",
  "RU-ROS": "/i/flags/RU/RU-ROS.svg.png",
  "RU-RYA": "/i/flags/RU/RU-RYA.svg.png",
  "RU-SA": "/i/flags/RU/RU-SA.svg.png",
  "RU-SAK": "/i/flags/RU/RU-SAK.svg.png",
  "RU-SAM": "/i/flags/RU/RU-SAM.svg.png",
  "RU-SAR": "/i/flags/RU/RU-SAR.svg.png",
  "RU-SE": "/i/flags/RU/RU-SE.svg.png",
  "RU-SMO": "/i/flags/RU/RU-SMO.svg.png",
  "RU-SPE": "/i/flags/RU/RU-SPE.svg.png",
  "RU-STA": "/i/flags/RU/RU-STA.svg.png",
  "RU-SVE": "/i/flags/RU/RU-SVE.svg.png",
  "RU-TA": "/i/flags/RU/RU-TA.svg.png",
  "RU-TAM": "/i/flags/RU/RU-TAM.svg.png",
  "RU-TOM": "/i/flags/RU/RU-TOM.svg.png",
  "RU-TUL": "/i/flags/RU/RU-TUL.svg.png",
  "RU-TVE": "/i/flags/RU/RU-TVE.svg.png",
  "RU-TY": "/i/flags/RU/RU-TY.svg.png",
  "RU-TYU": "/i/flags/RU/RU-TYU.svg.png",
  "RU-UD": "/i/flags/RU/RU-UD.svg.png",
  "RU-ULY": "/i/flags/RU/RU-ULY.svg.png",
  "RU-VGG": "/i/flags/RU/RU-VGG.svg.png",
  "RU-VLA": "/i/flags/RU/RU-VLA.svg.png",
  "RU-VLG": "/i/flags/RU/RU-VLG.svg.png",
  "RU-VOR": "/i/flags/RU/RU-VOR.svg.png",
  "RU-YAN": "/i/flags/RU/RU-YAN.svg.png",
  "RU-YAR": "/i/flags/RU/RU-YAR.svg.png",
  "RU-YEV": "/i/flags/RU/RU-YEV.svg.png",
  "RU-ZAB": "/i/flags/RU/RU-ZAB.svg.png",
  "RU:CR": "/i/flags/RU/RU:CR.svg.png",
  "SE-I": "/i/flags/SE/SE-I.svg.png",
  "SH-AC": "/i/flags/SH/SH-AC.svg.png",
  "SH-HL": "/i/flags/SH/SH-HL.svg.png",
  "SH-TA": "/i/flags/SH/SH-TA.svg.png",
  "UA-05": "/i/flags/UA/UA-05.svg.png",
  "UA-07": "/i/flags/UA/UA-07.svg.png",
  "UA-09": "/i/flags/UA/UA-09.svg.png",
  "UA-12": "/i/flags/UA/UA-12.svg.png",
  "UA-14": "/i/flags/UA/UA-14.svg.png",
  "UA-18": "/i/flags/UA/UA-18.svg.png",
  "UA-21": "/i/flags/UA/UA-21.svg.png",
  "UA-23": "/i/flags/UA/UA-23.svg.png",
  "UA-26": "/i/flags/UA/UA-26.svg.png",
  "UA-30": "/i/flags/UA/UA-30.svg.png",
  "UA-32": "/i/flags/UA/UA-32.svg.png",
  "UA-35": "/i/flags/UA/UA-35.svg.png",
  "UA-40": "/i/flags/UA/UA-40.svg.png",
  "UA-43": "/i/flags/UA/UA-43.svg.png",
  "UA-46": "/i/flags/UA/UA-46.svg.png",
  "UA-48": "/i/flags/UA/UA-48.svg.png",
  "UA-51": "/i/flags/UA/UA-51.svg.png",
  "UA-53": "/i/flags/UA/UA-53.svg.png",
  "UA-56": "/i/flags/UA/UA-56.svg.png",
  "UA-59": "/i/flags/UA/UA-59.svg.png",
  "UA-61": "/i/flags/UA/UA-61.svg.png",
  "UA-63": "/i/flags/UA/UA-63.svg.png",
  "UA-65": "/i/flags/UA/UA-65.svg.png",
  "UA-68": "/i/flags/UA/UA-68.svg.png",
  "UA-71": "/i/flags/UA/UA-71.svg.png",
  "UA-74": "/i/flags/UA/UA-74.svg.png",
  "UA-77": "/i/flags/UA/UA-77.svg.png",
  "UA-K": "/i/flags/UA/UA-K.svg.png",
  "US-AK": "/i/flags/US/US-AK.svg.png",
  "US-AL": "/i/flags/US/US-AL.svg.png",
  "US-AR": "/i/flags/US/US-AR.svg.png",
  "US-AS": "/i/flags/US/US-AS.svg.png",
  "US-AZ": "/i/flags/US/US-AZ.svg.png",
  "US-CA": "/i/flags/US/US-CA.svg.png",
  "US-CO": "/i/flags/US/US-CO.svg.png",
  "US-CT": "/i/flags/US/US-CT.svg.png",
  "US-DC": "/i/flags/US/US-DC.svg.png",
  "US-DE": "/i/flags/US/US-DE.svg.png",
  "US-FL": "/i/flags/US/US-FL.svg.png",
  "US-GA": "/i/flags/US/US-GA.svg.png",
  "US-GU": "/i/flags/US/US-GU.svg.png",
  "US-HI": "/i/flags/US/US-HI.svg.png",
  "US-IA": "/i/flags/US/US-IA.svg.png",
  "US-ID": "/i/flags/US/US-ID.svg.png",
  "US-IL": "/i/flags/US/US-IL.svg.png",
  "US-IN": "/i/flags/US/US-IN.svg.png",
  "US-KS": "/i/flags/US/US-KS.svg.png",
  "US-KY": "/i/flags/US/US-KY.svg.png",
  "US-LA": "/i/flags/US/US-LA.svg.png",
  "US-MA": "/i/flags/US/US-MA.svg.png",
  "US-MD": "/i/flags/US/US-MD.svg.png",
  "US-ME": "/i/flags/US/US-ME.svg.png",
  "US-MI": "/i/flags/US/US-MI.svg.png",
  "US-MN": "/i/flags/US/US-MN.svg.png",
  "US-MO": "/i/flags/US/US-MO.svg.png",
  "US-MP": "/i/flags/US/US-MP.svg.png",
  "US-MS": "/i/flags/US/US-MS.svg.png",
  "US-MT": "/i/flags/US/US-MT.svg.png",
  "US-NC": "/i/flags/US/US-NC.svg.png",
  "US-ND": "/i/flags/US/US-ND.svg.png",
  "US-NE": "/i/flags/US/US-NE.svg.png",
  "US-NH": "/i/flags/US/US-NH.svg.png",
  "US-NJ": "/i/flags/US/US-NJ.svg.png",
  "US-NM": "/i/flags/US/US-NM.svg.png",
  "US-NV": "/i/flags/US/US-NV.svg.png",
  "US-NY": "/i/flags/US/US-NY.svg.png",
  "US-OH": "/i/flags/US/US-OH.svg.png",
  "US-OK": "/i/flags/US/US-OK.svg.png",
  "US-OR": "/i/flags/US/US-OR.svg.png",
  "US-PA": "/i/flags/US/US-PA.svg.png",
  "US-PR": "/i/flags/US/US-PR.svg.png",
  "US-RI": "/i/flags/US/US-RI.svg.png",
  "US-SC": "/i/flags/US/US-SC.svg.png",
  "US-SD": "/i/flags/US/US-SD.svg.png",
  "US-TN": "/i/flags/US/US-TN.svg.png",
  "US-TX": "/i/flags/US/US-TX.svg.png",
  "US-UM": "/i/flags/US/US-UM.svg.png",
  "US-UT": "/i/flags/US/US-UT.svg.png",
  "US-VA": "/i/flags/US/US-VA.svg.png",
  "US-VI": "/i/flags/US/US-VI.svg.png",
  "US-VT": "/i/flags/US/US-VT.svg.png",
  "US-WA": "/i/flags/US/US-WA.svg.png",
  "US-WI": "/i/flags/US/US-WI.svg.png",
  "US-WV": "/i/flags/US/US-WV.svg.png",
  "US-WY": "/i/flags/US/US-WY.svg.png",
  "UZ-QR": "/i/flags/UZ/UZ-QR.svg.png",
  "VE-O": "/i/flags/VE/VE-O.svg.png",
  "XJ": "/i/flags/XJ/XJ.svg.png",
  "ZA-EC": "/i/flags/ZA/ZA-EC.png",
  "ZA-FS": "/i/flags/ZA/ZA-FS.png",
  "ZA-GP": "/i/flags/ZA/ZA-GP.png",
  "ZA-KZN": "/i/flags/ZA/ZA-KZN.png",
  "ZA-LP": "/i/flags/ZA/ZA-LP.png",
  "ZA-MP": "/i/flags/ZA/ZA-MP.svg.png",
  "ZA-NC": "/i/flags/ZA/ZA-NC.png",
  "ZA-NW": "/i/flags/ZA/ZA-NW.png",
  "ZA-WC": "/i/flags/ZA/ZA-WC.png",
  "AD": "/i/flags/unp/AD.svg.png",
  "AE": "/i/flags/unp/AE.svg.png",
  "AF": "/i/flags/unp/AF.svg.png",
  "AG": "/i/flags/unp/AG.svg.png",
  "AI": "/i/flags/unp/AI.svg.png",
  "AL": "/i/flags/unp/AL.svg.png",
  "AM": "/i/flags/unp/AM.svg.png",
  "AO": "/i/flags/unp/AO.svg.png",
  "AQ": "/i/flags/unp/AQ.svg.png",
  "AR": "/i/flags/unp/AR.svg.png",
  "AS": "/i/flags/unp/AS.svg.png",
  "AT": "/i/flags/unp/AT.svg.png",
  "AU": "/i/flags/unp/AU.svg.png",
  "AW": "/i/flags/unp/AW.svg.png",
  "AX": "/i/flags/unp/AX.svg.png",
  "AZ": "/i/flags/unp/AZ.svg.png",
  "BA": "/i/flags/unp/BA.svg.png",
  "BB": "/i/flags/unp/BB.svg.png",
  "BD": "/i/flags/unp/BD.svg.png",
  "BE": "/i/flags/unp/BE.svg.png",
  "BF": "/i/flags/unp/BF.svg.png",
  "BG": "/i/flags/unp/BG.svg.png",
  "BH": "/i/flags/unp/BH.svg.png",
  "BI": "/i/flags/unp/BI.svg.png",
  "BJ": "/i/flags/unp/BJ.svg.png",
  "BL": "/i/flags/unp/BL.svg.png",
  "BM": "/i/flags/unp/BM.svg.png",
  "BN": "/i/flags/unp/BN.svg.png",
  "BO": "/i/flags/unp/BO.svg.png",
  "BQ": "/i/flags/unp/BQ.svg.png",
  "BR": "/i/flags/unp/BR.svg.png",
  "BS": "/i/flags/unp/BS.svg.png",
  "BT": "/i/flags/unp/BT.svg.png",
  "BV": "/i/flags/unp/BV.svg.png",
  "BW": "/i/flags/unp/BW.svg.png",
  "BY": "/i/flags/unp/BY.svg.png",
  "BZ": "/i/flags/unp/BZ.svg.png",
  "CA": "/i/flags/unp/CA.svg.png",
  "CC": "/i/flags/unp/CC.svg.png",
  "CD": "/i/flags/unp/CD.svg.png",
  "CF": "/i/flags/unp/CF.svg.png",
  "CG": "/i/flags/unp/CG.svg.png",
  "CH": "/i/flags/unp/CH.svg.png",
  "CI": "/i/flags/unp/CI.svg.png",
  "CK": "/i/flags/unp/CK.svg.png",
  "CL": "/i/flags/unp/CL.svg.png",
  "CM": "/i/flags/unp/CM.svg.png",
  "CN": "/i/flags/unp/CN.svg.png",
  "CO": "/i/flags/unp/CO.svg.png",
  "CR": "/i/flags/unp/CR.svg.png",
  "CU": "/i/flags/unp/CU.svg.png",
  "CV": "/i/flags/unp/CV.svg.png",
  "CW": "/i/flags/unp/CW.svg.png",
  "CX": "/i/flags/unp/CX.svg.png",
  "CY": "/i/flags/unp/CY.svg.png",
  "CZ": "/i/flags/unp/CZ.svg.png",
  "DE": "/i/flags/unp/DE.svg.png",
  "DJ": "/i/flags/unp/DJ.svg.png",
  "DK": "/i/flags/unp/DK.svg.png",
  "DM": "/i/flags/unp/DM.svg.png",
  "DO": "/i/flags/unp/DO.svg.png",
  "DZ": "/i/flags/unp/DZ.svg.png",
  "EA": "/i/flags/unp/EA.svg.png",
  "EC": "/i/flags/unp/EC.svg.png",
  "EE": "/i/flags/unp/EE.svg.png",
  "EG": "/i/flags/unp/EG.svg.png",
  "EH": "/i/flags/unp/EH.svg.png",
  "ER": "/i/flags/unp/ER.svg.png",
  "ES": "/i/flags/unp/ES.svg.png",
  "ET": "/i/flags/unp/ET.svg.png",
  "EU": "/i/flags/unp/EU.svg.png",
  "FI": "/i/flags/unp/FI.svg.png",
  "FJ": "/i/flags/unp/FJ.svg.png",
  "FK": "/i/flags/unp/FK.svg.png",
  "FM": "/i/flags/unp/FM.svg.png",
  "FO": "/i/flags/unp/FO.svg.png",
  "FR": "/i/flags/unp/FR.svg.png",
  "GA": "/i/flags/unp/GA.svg.png",
  "GB": "/i/flags/unp/GB.svg.png",
  "GD": "/i/flags/unp/GD.svg.png",
  "GE": "/i/flags/unp/GE.svg.png",
  "GF": "/i/flags/unp/GF.svg.png",
  "GG": "/i/flags/unp/GG.svg.png",
  "GH": "/i/flags/unp/GH.svg.png",
  "GI": "/i/flags/unp/GI.svg.png",
  "GL": "/i/flags/unp/GL.svg.png",
  "GM": "/i/flags/unp/GM.svg.png",
  "GN": "/i/flags/unp/GN.svg.png",
  "GP": "/i/flags/unp/GP.svg.png",
  "GQ": "/i/flags/unp/GQ.svg.png",
  "GR": "/i/flags/unp/GR.svg.png",
  "GS": "/i/flags/unp/GS.svg.png",
  "GT": "/i/flags/unp/GT.svg.png",
  "GU": "/i/flags/unp/GU.svg.png",
  "GW": "/i/flags/unp/GW.svg.png",
  "GY": "/i/flags/unp/GY.svg.png",
  "HK": "/i/flags/unp/HK.svg.png",
  "HM": "/i/flags/unp/HM.svg.png",
  "HN": "/i/flags/unp/HN.svg.png",
  "HR": "/i/flags/unp/HR.svg.png",
  "HT": "/i/flags/unp/HT.svg.png",
  "HU": "/i/flags/unp/HU.svg.png",
  "IC": "/i/flags/unp/IC.svg.png",
  "ID": "/i/flags/unp/ID.svg.png",
  "IE": "/i/flags/unp/IE.svg.png",
  "IL": "/i/flags/unp/IL.svg.png",
  "IM": "/i/flags/unp/IM.svg.png",
  "IN": "/i/flags/unp/IN.svg.png",
  "IO": "/i/flags/unp/IO.svg.png",
  "IQ": "/i/flags/unp/IQ.svg.png",
  "IR": "/i/flags/unp/IR.svg.png",
  "IS": "/i/flags/unp/IS.svg.png",
  "IT": "/i/flags/unp/IT.svg.png",
  "JE": "/i/flags/unp/JE.svg.png",
  "JM": "/i/flags/unp/JM.svg.png",
  "JO": "/i/flags/unp/JO.svg.png",
  "JP": "/i/flags/unp/JP.svg.png",
  "KE": "/i/flags/unp/KE.svg.png",
  "KG": "/i/flags/unp/KG.svg.png",
  "KH": "/i/flags/unp/KH.svg.png",
  "KI": "/i/flags/unp/KI.svg.png",
  "KM": "/i/flags/unp/KM.svg.png",
  "KN": "/i/flags/unp/KN.svg.png",
  "KP": "/i/flags/unp/KP.svg.png",
  "KR": "/i/flags/unp/KR.svg.png",
  "KW": "/i/flags/unp/KW.svg.png",
  "KY": "/i/flags/unp/KY.svg.png",
  "KZ": "/i/flags/unp/KZ.svg.png",
  "LA": "/i/flags/unp/LA.svg.png",
  "LB": "/i/flags/unp/LB.svg.png",
  "LC": "/i/flags/unp/LC.svg.png",
  "LI": "/i/flags/unp/LI.svg.png",
  "LK": "/i/flags/unp/LK.svg.png",
  "LR": "/i/flags/unp/LR.svg.png",
  "LS": "/i/flags/unp/LS.svg.png",
  "LT": "/i/flags/unp/LT.svg.png",
  "LU": "/i/flags/unp/LU.svg.png",
  "LV": "/i/flags/unp/LV.svg.png",
  "LY": "/i/flags/unp/LY.svg.png",
  "MA": "/i/flags/unp/MA.svg.png",
  "MC": "/i/flags/unp/MC.svg.png",
  "MD": "/i/flags/unp/MD.svg.png",
  "ME": "/i/flags/unp/ME.svg.png",
  "MF": "/i/flags/unp/MF.svg.png",
  "MG": "/i/flags/unp/MG.svg.png",
  "MH": "/i/flags/unp/MH.svg.png",
  "MK": "/i/flags/unp/MK.svg.png",
  "ML": "/i/flags/unp/ML.svg.png",
  "MM": "/i/flags/unp/MM.svg.png",
  "MN": "/i/flags/unp/MN.svg.png",
  "MO": "/i/flags/unp/MO.svg.png",
  "MP": "/i/flags/unp/MP.svg.png",
  "MQ": "/i/flags/unp/MQ.svg.png",
  "MR": "/i/flags/unp/MR.svg.png",
  "MS": "/i/flags/unp/MS.svg.png",
  "MT": "/i/flags/unp/MT.svg.png",
  "MU": "/i/flags/unp/MU.svg.png",
  "MV": "/i/flags/unp/MV.svg.png",
  "MW": "/i/flags/unp/MW.svg.png",
  "MX": "/i/flags/unp/MX.svg.png",
  "MY": "/i/flags/unp/MY.svg.png",
  "MZ": "/i/flags/unp/MZ.svg.png",
  "NA": "/i/flags/unp/NA.svg.png",
  "NC": "/i/flags/unp/NC.svg.png",
  "NE": "/i/flags/unp/NE.svg.png",
  "NF": "/i/flags/unp/NF.svg.png",
  "NG": "/i/flags/unp/NG.svg.png",
  "NI": "/i/flags/unp/NI.svg.png",
  "NL": "/i/flags/unp/NL.svg.png",
  "NO": "/i/flags/unp/NO.svg.png",
  "NP": "/i/flags/unp/NP.svg.png",
  "NR": "/i/flags/unp/NR.svg.png",
  "NU": "/i/flags/unp/NU.svg.png",
  "NZ": "/i/flags/unp/NZ.svg.png",
  "OM": "/i/flags/unp/OM.svg.png",
  "PA": "/i/flags/unp/PA.svg.png",
  "PE": "/i/flags/unp/PE.svg.png",
  "PF": "/i/flags/unp/PF.svg.png",
  "PG": "/i/flags/unp/PG.svg.png",
  "PH": "/i/flags/unp/PH.svg.png",
  "PK": "/i/flags/unp/PK.svg.png",
  "PL": "/i/flags/unp/PL.svg.png",
  "PM": "/i/flags/unp/PM.svg.png",
  "PN": "/i/flags/unp/PN.svg.png",
  "PR": "/i/flags/unp/PR.svg.png",
  "PS": "/i/flags/unp/PS.svg.png",
  "PT": "/i/flags/unp/PT.svg.png",
  "PW": "/i/flags/unp/PW.svg.png",
  "PY": "/i/flags/unp/PY.svg.png",
  "QA": "/i/flags/unp/QA.svg.png",
  "RE": "/i/flags/unp/RE.svg.png",
  "RO": "/i/flags/unp/RO.svg.png",
  "RS": "/i/flags/unp/RS.svg.png",
  "RU": "/i/flags/unp/RU.svg.png",
  "RW": "/i/flags/unp/RW.svg.png",
  "SA": "/i/flags/unp/SA.svg.png",
  "SB": "/i/flags/unp/SB.svg.png",
  "SC": "/i/flags/unp/SC.svg.png",
  "SD": "/i/flags/unp/SD.svg.png",
  "SE": "/i/flags/unp/SE.svg.png",
  "SG": "/i/flags/unp/SG.svg.png",
  "SH": "/i/flags/unp/SH.svg.png",
  "SI": "/i/flags/unp/SI.svg.png",
  "SJ": "/i/flags/unp/SJ.svg.png",
  "SK": "/i/flags/unp/SK.svg.png",
  "SL": "/i/flags/unp/SL.svg.png",
  "SM": "/i/flags/unp/SM.svg.png",
  "SN": "/i/flags/unp/SN.svg.png",
  "SO": "/i/flags/unp/SO.svg.png",
  "SR": "/i/flags/unp/SR.svg.png",
  "SS": "/i/flags/unp/SS.svg.png",
  "ST": "/i/flags/unp/ST.svg.png",
  "SV": "/i/flags/unp/SV.svg.png",
  "SX": "/i/flags/unp/SX.svg.png",
  "SY": "/i/flags/unp/SY.svg.png",
  "SZ": "/i/flags/unp/SZ.svg.png",
  "TC": "/i/flags/unp/TC.svg.png",
  "TD": "/i/flags/unp/TD.svg.png",
  "TF": "/i/flags/unp/TF.svg.png",
  "TG": "/i/flags/unp/TG.svg.png",
  "TH": "/i/flags/unp/TH.svg.png",
  "TJ": "/i/flags/unp/TJ.svg.png",
  "TK": "/i/flags/unp/TK.svg.png",
  "TL": "/i/flags/unp/TL.svg.png",
  "TM": "/i/flags/unp/TM.svg.png",
  "TN": "/i/flags/unp/TN.svg.png",
  "TO": "/i/flags/unp/TO.svg.png",
  "TR": "/i/flags/unp/TR.svg.png",
  "TT": "/i/flags/unp/TT.svg.png",
  "TV": "/i/flags/unp/TV.svg.png",
  "TW": "/i/flags/unp/TW.svg.png",
  "TZ": "/i/flags/unp/TZ.svg.png",
  "UA": "/i/flags/unp/UA.svg.png",
  "UG": "/i/flags/unp/UG.svg.png",
  "UM": "/i/flags/unp/UM.svg.png",
  "US": "/i/flags/unp/US.svg.png",
  "UY": "/i/flags/unp/UY.svg.png",
  "UZ": "/i/flags/unp/UZ.svg.png",
  "VA": "/i/flags/unp/VA.svg.png",
  "VC": "/i/flags/unp/VC.svg.png",
  "VE": "/i/flags/unp/VE.svg.png",
  "VG": "/i/flags/unp/VG.svg.png",
  "VI": "/i/flags/unp/VI.svg.png",
  "VN": "/i/flags/unp/VN.svg.png",
  "VU": "/i/flags/unp/VU.svg.png",
  "WF": "/i/flags/unp/WF.svg.png",
  "WS": "/i/flags/unp/WS.svg.png",
  "XA": "/i/flags/unp/XA.svg.png",
  "XC": "/i/flags/unp/XC.svg.png",
  "XD": "/i/flags/unp/XD.svg.png",
  "XK": "/i/flags/unp/XK.svg.png",
  "XN": "/i/flags/unp/XN.svg.png",
  "XO": "/i/flags/unp/XO.svg.png",
  "XR": "/i/flags/unp/XR.svg.png",
  "XS": "/i/flags/unp/XS.svg.png",
  "XT": "/i/flags/unp/XT.svg.png",
  "YE": "/i/flags/unp/YE.svg.png",
  "YT": "/i/flags/unp/YT.svg.png",
  "ZA": "/i/flags/unp/ZA.svg.png",
  "ZM": "/i/flags/unp/ZM.svg.png",
  "ZW": "/i/flags/unp/ZW.svg.png",
  "timestamp": 1752950837
};
